import { render, staticRenderFns } from "./FormsSidebar.vue?vue&type=template&id=64e3c560&scoped=true"
import script from "./FormsSidebar.vue?vue&type=script&lang=js"
export * from "./FormsSidebar.vue?vue&type=script&lang=js"
import style0 from "./FormsSidebar.vue?vue&type=style&index=0&id=64e3c560&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e3c560",
  null
  
)

export default component.exports